import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import LogSapFCountTable from "../components/LogSapFCountTable";

import axios from "axios";

export default function Employers(props) {

  const {
    chooseSapId,
    setChooseSapId,
    setShowLog,
    showLog,
  } = props;

  const [logRows, setLogRows] = useState([]);
  const [isError, setIsError] = useState(false);
  const [sortField, setSortField] = useState("");
  const [orderBy, setOrderBy] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(1000);
  const [logId, setLogId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const onLogRows = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}employee/${chooseSapId}`,

      )
      .then(({ data }) => {
        setIsLoading(false);
        setLogRows(data.employeeFingers);
        setIsError(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
        setLogRows([]);
      });
  };

  useEffect(() => {
    if (showLog) {
      onLogRows(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, showLog]);









  return (
    <Modal
      show={showLog}
      onHide={setShowLog}
      size="xl"
      aria-labelledby="edit"
      centered
      className="pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="delete">Əməkdaşlar üzrə barmaq izləri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row bg-white rounded">

          <LogSapFCountTable
            logRows={logRows}
            chooseSapId={chooseSapId}
            setChooseSapId={setChooseSapId}
            setSortField={setSortField}
            setOrderByTable={setOrderBy}
            sortField={sortField}
            orderBy={orderBy}
            isLoading={isLoading}
            isError={isError}
            updateSkip={setSkip}
            updateTake={setTake}
            take={take}
            setLogId={setLogId}
            logId={logId}
        
          />
        </div>
      </Modal.Body>
   

    </Modal>
  );
}
